<template>
    <div class="duplicate">
      <div class="cont-box">
        <div class="title">
          <Title text="查重记录" />
          <div>
          <el-form
            ref="search"
            :inline="true"
            :model="condition"
            :rules="searchRules"
            class="search-form"
            slot="search"
            label-width="80px"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <!-- <div>
                  <el-form-item prop="paper_plan_student_id">
                    <el-select
                      v-model="condition.paper_plan_student_id"
                      placeholder="请选择论文计划"
                      clearable
                      filterable
                      style="width: 300px;"
                    >
                      <el-option
                        v-for="item in thesisPlanList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="loadData">确认</el-button>
                  </el-form-item>
                </div> -->
              </div>
              <div>
                <div class="btn-box">
                  <div>
                    <el-form-item>
                      <el-button
                        type="primary"
                        class="link-btn"
                        @click="duplicateCheckClick"
                      >提交申请</el-button>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        </div>
        <div>
          <el-table
            :data="list"
            headerRowClassName="uni-primary-table-header"
            stripe
            border
          >
            <el-table-column prop="student_title" align="center" label="学生姓名">
            </el-table-column>
            <el-table-column prop="paperviewurl" align="center" label="查重文件">
              <template slot-scope="{row}">
                <div v-for="(item, index) in JSON.parse(row.files_url)" :key="index">
                    <el-button class="link-btn" type="text" @click="seeFile(item.url, item.name)">{{ item.name }}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="paperguid" align="center" label="检测报告编码">
            </el-table-column>
            <el-table-column prop="percentage" align="center" label="查重相似率">
            </el-table-column>
            <el-table-column prop="paperviewurl" align="center" label="在线预览链接">
              <template slot-scope="{row}">
                <a :href="row.paperviewurl" target="_blank">{{ row.paperviewurl }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="paperdownurl" align="center" label="下载报告地址">
              <template slot-scope="{row}">
                <a :href="row.paperdownurl" target="_blank">{{ row.paperdownurl }}</a>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="{row}">
                <el-button
                  class="link-btn"
                  type="text"
                  @click="enterDetection(row)"
                >进入检测</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 提交申请 -->
        <el-dialog
            class="duplicateCheck"
            title="提交申请"
            :visible.sync="isShowDuplicateCheck"
            width="40%"
            @close="duplicateCheckClose"
        >
        <div class="dialog" >
            <el-form
                ref="duplicateCheck"
                :model="duplicateCheckData"
                :rules="duplicateCheckRules"
                label-width="160px"
            >
                <el-form-item label="查重文件：" prop="files_url">
                    <FalConUpload
                        ref="uploadDuplicateCheck"
                        listStyle='text'
                        accept=".docx,.doc,.pdf,.txt"
                        :limit="1"
                        :isFile="true"
                        :isAccept="true"
                        @handleRemove="duplicateCheckHandleRemove"
                        @handleChange="duplicateCheckHandleChange"
                    ></FalConUpload>
                    <div>
                        <span class="tips">说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件</span>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align: center">
            <el-button @click="isShowDuplicateCheck = false">取 消</el-button>
            <el-button type="primary" :loading="duplicateCheckLoading" @click="duplicateCheckSubmit">确 定</el-button>
        </div>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import {
    pracGetCnki,
    pracUpCnki,
    pracGetDupUrl,
  } from "@/api/practicalAssessment";
  
  import {arrAttDel, deepClone} from '@/utils/func';
  
  import {downladUrl} from '@/utils/func';
  import FalConUpload from "@/components/uploadFile";
  import { putObject, uploadFiles, deleteObject } from "@/utils/upload";
  import esignHandle from '@/components/esignHandle';
  
  export default {
    name: "duplicate",
    // esignHandle
    components: { FalConUpload,  },
    filters: {
      // 查重状态
      dupCheckStatusFilter(v){
        const obj = {
          0: '未开始',
          1: '已通过',
          2: '未通过',
        };
        return obj[v];
      },
      // 设计资料评分状态
      scorePassStatusFliter(v) {
        const obj = {
          0: '评分中',
          1: '已通过',
          2: '未通过',
        };
        return obj[v];
      },
      // 查重附加审核状态
      duplicateStatusFilter(v){
        const obj = {
          0: '待检测',
          1: '已通过',
          2: '未通过',
        };
        return obj[v];
      },
      // 查重附件审核状态 样式
      duplicateStatusStyle(v){
        const obj = {
          0: '',
          1: 'success',
          2: 'danger',
        };
        return obj[v];
      },
    },
    data() {
      return {
        condition: {
            prac_student_id: this.$route.query.id,  //论文计划
        },
        searchRules: {
        //   paper_plan_student_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
        },
  
        list:[],
        listTotal: -1,

        // 提交申请
        isShowDuplicateCheck: false,
        duplicateCheckData: {
            prac_student_id: '',  //id
            files_url: '',  //查重文件
        },
        duplicateCheckRules: {
            files_url: [{ required: true, trigger: 'change', message: "请上传查重文件" }],
        },
        duplicateCheckLoading: false,  //弹窗 提交申请 加载
  
      };
    },
    created() {
        this.getListFn();
    },
    methods: {
        // 点击文件
        seeFile(url, name){
            downladUrl(url, name);
        },
      // 点击进去检测
      enterDetection(row){
        let data = {
            prac_cnki_id: row.id,
        };
        pracGetDupUrl(data).then(res => {
          if(res.code == 200){
            window.open(res.result.redirect_url, '_blank');
          }
        });
      },
        // 弹窗 提交申请 提交
        duplicateCheckSubmit(){
            this.$refs["duplicateCheck"].validate(async (valid) => {
                if (valid) {
                    this.duplicateCheckLoading = true;
                    let data = deepClone(this.duplicateCheckData);
                    let upload = new Promise((resolve, reject) => {
                        uploadFiles(this.duplicateCheckData.files_url, (urls) => {
                            resolve(urls);
                        }, null, 'student', '', true);
                    });
                    data.files_url = await upload;
                    pracUpCnki(data).then(async res => {
                        if(res.code == 200){
                            this.$message.success('保存成功');
                            this.isShowDuplicateCheck = false;
                            // window.open(res.result.redirect_url, '_blank');
                            this.getListFn();
                        }
                    }).finally(() => {
                        this.duplicateCheckLoading = false;
                    });
                }
            })
        },
        // 弹窗 提交申请 关闭
        duplicateCheckClose(){
            this.duplicateCheckData = {
                prac_student_id: '',  //id
                files_url: '',  //查重文件
            };
            if(this.$refs['uploadDuplicateCheck']) this.$refs['uploadDuplicateCheck'].reset();
            // if(this.$refs['uploadFile']) this.$refs['uploadFile'].reset();
            this.$nextTick(() => {
                this.$refs["duplicateCheck"].clearValidate();
            });
        },
        // 弹窗 提交申请 查重文件 删除
        duplicateCheckHandleRemove(data){
            this.duplicateCheckData.files_url = data.fileList;
        },
        // 弹窗 提交申请 查重文件 多传
        duplicateCheckHandleChange(data){
            this.duplicateCheckData.files_url = data.fileList;
        },
        // 点击 提交申请
        duplicateCheckClick(){
            this.duplicateCheckData.prac_student_id = this.condition.prac_student_id;
            this.isShowDuplicateCheck = true;
        },
      getListFn(){
        let data = {
            prac_student_id: this.condition.prac_student_id
        };
        pracGetCnki(data).then(res => {
          if(res.code == 200){
            this.list = res.result;
          }
        });
      },
    },
    beforeDestroy() {
  
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .duplicate {
    // min-height: $contentH;
    min-height: calc(100vh - 40px);
    padding: $sideMargin;
    padding-bottom: 0;
    .cont-box{
      background: $white;
      min-height: inherit;
      padding: 0 20px 20px;
    }
  }
  </style>
  